import {fetchStockAvailability} from "./fetchStockAvailability";
import {insertStockAvailabilityPill} from "./insertStockAvailabilityPill";
import {useSelectedBranchFromLocalStorage} from "../branch-selector/branchSelector";

const getUserType = (win) => {
    const wrapper = win.document.querySelector(`.product-search-page-body-wrapper`);
    return wrapper ? wrapper.getAttribute('data-user-type') : null;
}

const getSelectedBranchNumber = (userDetails) => {
    const [selectedBranchInfo] = useSelectedBranchFromLocalStorage(userDetails)

    if (selectedBranchInfo) {
        return selectedBranchInfo.storeCode
    } else if (userDetails && userDetails.HomeBranch) {
        return userDetails.HomeBranch.branchNumber
    } else {
        return null
    }
}

export const initStockAvailabilityPill = async (win, userDetails) => {
    if (getUserType(win) !== 'MAX_USER') {
        return
    }

    const productTiles = win.document.querySelectorAll(".product-tile")
    const productCodes = Array.from(productTiles).map(product => product.dataset.productCode)

    const branchNumber = getSelectedBranchNumber(userDetails)
    const stockAvailability = branchNumber && productCodes && await fetchStockAvailability(
        branchNumber,
        productCodes
    )

    if (!stockAvailability) {
        return
    }

    addEventListenersAndStockAvailabilityToProducts(productTiles, stockAvailability)
}

const addEventListenersAndStockAvailabilityToProducts = (productTiles, stockAvailability) => {
    productTiles.forEach(product => {
        addEventListenersToProduct(stockAvailability, product)
        addStockAvailabilityIntoProduct(stockAvailability, product, 1, "1")
    })
}

export const addEventListenersToProduct = (stockAvailability, product) => {
    // quantity change event
    product
        .querySelector(".product-tile__qty-field-container .product-tile__qty-field")
        .addEventListener("change", event => {
            addStockAvailabilityIntoProduct(stockAvailability, product, event.target.value, product.querySelector("add-to-cart").dataset.unit)
        })
    // quantity increment events
    product
        .querySelectorAll(".product-tile__qty-switch--js-inc, .product-tile__qty-switch--js-dec")
        .forEach(quantitySwitch => quantitySwitch.addEventListener("click", event => {
            addStockAvailabilityIntoProduct(stockAvailability, product, event.target.value, product.querySelector("add-to-cart").dataset.unit)
        }))
    // uom change events
    product
        .querySelectorAll(".product-tile__unit-switch-radio")
        .forEach(unitOfMeasure => unitOfMeasure.addEventListener("change", () => {
            addStockAvailabilityIntoProduct(
                stockAvailability,
                product,
                product.querySelector("add-to-cart").dataset.quantity,
                product.querySelector(`.product-tile__unit-switch-radio:checked`).value || '1'
            )
        }))
}

const addStockAvailabilityIntoProduct = (
    stockAvailability,
    product,
    quantity,
    unitOfMeasure
) => {
    const stockAvailabilityStatus = getStockAvailabilityStatus(stockAvailability, product, quantity, unitOfMeasure)

    product.dataset.stockAvailability = stockAvailabilityStatus.availabilityDescription
    if (stockAvailability.showStockAvailability) {
        insertStockAvailabilityPill(stockAvailabilityStatus, product)
    }
}

export const getStockAvailabilityStatus = (stockAvailability, product, quantity, unit) => {
    const productCode = product.dataset.productCode
    const productStockAvailability = stockAvailability.products.find(stockAvailabilityProduct => stockAvailabilityProduct.productNumber.toString() === productCode)
    if (!productStockAvailability) {
        return
    }

    const productStockAvailabilityPack = productStockAvailability.packs
        .find(pack => pack.pack === `PACK${unit === "1" || unit === "2" ? unit : "1"}`)
    const stockRange = productStockAvailabilityPack && productStockAvailabilityPack.stockRanges
        .find(stockRange => quantity > stockRange.minQuantityExclusive && quantity <= stockRange.maxQuantityInclusive)

    return stockRange
        ? {availability: stockRange.availability, availabilityDescription: stockRange.availabilityDescription }
        : {availability: "UNAVAILABLE", availabilityDescription: "Not Available"}
}
